export function getSiteUrl(): string {
  return (
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== "undefined"
      ? window.location.origin
      : "https://www.7cantos.com")
  );
}

export function buildAbsolutePageUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getSiteUrl()}${normalizedPath}`;
}
